import { AVATAR_SIZES } from '../Constants';
import { Size } from '../types/SharedPropTypes';

export const getDimensions = (size: Size) => {
  return {
    width: size !== AVATAR_SIZES.responsive ? AVATAR_SIZES[size] : null,
    height: size !== AVATAR_SIZES.responsive ? AVATAR_SIZES[size] : null,
  };
};
